import { createAction } from 'typesafe-actions';

import { ACTIONS } from './types';

export const setLastWinners = createAction(ACTIONS.SET_LAST_WINNERS)<string[]>();

export const addNewRoundToStatistics = createAction(ACTIONS.ADD_NEW_ROUND_RESULT)<string>();
